import React from 'react';

const C = {
  bg: '#0A0E1A', surface: '#111827', card: '#1a2235',
  border: '#1e2d45', text: '#E8EDF5', muted: '#6b7fa3',
  accent: '#00D4AA', navy: '#003366',
};

export default function PrivacyPage({ onClose }) {
  const S = { fontFamily: "'Sora', sans-serif", background: C.bg, minHeight: '100vh', color: C.text };

  const Section = ({ title, children }) => (
    <div style={{ marginBottom: 32 }}>
      <div style={{ fontSize: 16, fontWeight: 700, color: C.accent, marginBottom: 12, borderLeft: `3px solid ${C.accent}`, paddingLeft: 12 }}>{title}</div>
      <div style={{ fontSize: 14, lineHeight: 1.8, color: C.muted }}>{children}</div>
    </div>
  );

  return (
    <div style={{ ...S, position: "fixed", inset: 0, overflowY: "auto", zIndex: 500 }}>
      <div style={{ maxWidth: 680, margin: "0 auto", padding: "0 20px 60px" }}>

        <div style={{ padding: "20px 0 24px", display: "flex", alignItems: "center", gap: 16, position: "sticky", top: 0, background: C.bg, zIndex: 10, borderBottom: `1px solid ${C.border}`, marginBottom: 32 }}>
          <button onClick={onClose} style={{ background: "none", border: "none", color: C.muted, fontSize: 24, cursor: "pointer" }}>←</button>
          <div>
            <div style={{ fontWeight: 800, fontSize: 20, color: C.text }}>Politique de confidentialité</div>
            <div style={{ fontSize: 12, color: C.muted }}>PayChat — ZENVOI SARL · Mise à jour : Avril 2026</div>
          </div>
        </div>

        <div style={{ background: C.card, border: `1px solid ${C.border}`, borderRadius: 16, padding: 20, marginBottom: 32 }}>
          <div style={{ fontSize: 14, color: C.muted, lineHeight: 1.8 }}>
            Bienvenue sur <strong style={{ color: C.text }}>PayChat</strong>, application de messagerie et paiements mobiles de <strong style={{ color: C.text }}>ZENVOI SARL</strong> (BP 12619, Douala, Cameroun). Nous protégeons vos données personnelles conformément à la loi camerounaise n°2010/021 et aux standards internationaux.
          </div>
        </div>

        <Section title="1. Responsable du traitement">
          <strong style={{ color: C.text }}>ZENVOI SARL</strong> — ODZO EKOA Gilbert Beranger<br/>
          BP 12619 — Douala, Cameroun<br/>
          Email : GilbertOdzo@zenvoi.co | Tél : +237 697 008 362
        </Section>

        <Section title="2. Données collectées">
          <strong style={{ color: C.text }}>• Identité :</strong> nom, prénom, numéro de téléphone<br/>
          <strong style={{ color: C.text }}>• Connexion :</strong> adresse IP, date/heure, type d'appareil<br/>
          <strong style={{ color: C.text }}>• Messagerie :</strong> messages, photos, fichiers (chiffrés E2E)<br/>
          <strong style={{ color: C.text }}>• Financières :</strong> historique transactions, solde wallet<br/>
          <strong style={{ color: C.text }}>• Biométriques :</strong> reconnaissance faciale (traitée localement, jamais transmise)<br/>
          <strong style={{ color: C.text }}>• Techniques :</strong> jetons d'authentification, préférences
        </Section>

        <Section title="3. Finalités du traitement">
          • Fournir les services de messagerie et paiement<br/>
          • Vérifier votre identité et sécuriser votre compte<br/>
          • Traiter et enregistrer vos transactions financières<br/>
          • Envoyer notifications push et SMS de vérification<br/>
          • Détecter et prévenir les fraudes<br/>
          • Respecter nos obligations légales et réglementaires
        </Section>

        <Section title="4. Chiffrement et sécurité">
          <strong style={{ color: C.text }}>• Chiffrement E2E :</strong> ECDH P-256 + AES-GCM 256 — même ZENVOI ne peut pas lire vos messages<br/>
          <strong style={{ color: C.text }}>• Perfect Forward Secrecy :</strong> clés uniques par session<br/>
          <strong style={{ color: C.text }}>• HTTPS/TLS :</strong> toutes les communications chiffrées<br/>
          <strong style={{ color: C.text }}>• Double authentification :</strong> PIN + biométrie pour paiements<br/>
          <strong style={{ color: C.text }}>• Hébergement :</strong> serveurs Hetzner (Allemagne), conformes standards européens
        </Section>

        <Section title="5. Partage des données">
          Nous ne vendons jamais vos données. Partenaires autorisés :<br/><br/>
          <strong style={{ color: C.text }}>• Twilio :</strong> envoi SMS OTP<br/>
          <strong style={{ color: C.text }}>• Orange Money Cameroun :</strong> traitement paiements Mobile Money<br/>
          <strong style={{ color: C.text }}>• Autorités judiciaires :</strong> uniquement sur réquisition légale
        </Section>

        <Section title="6. Plafonds de transactions">
          Pour protéger vos fonds :<br/><br/>
          • Minimum par transaction : <strong style={{ color: C.text }}>50 FCFA</strong><br/>
          • Maximum par transaction P2P : <strong style={{ color: C.text }}>500 000 FCFA</strong><br/>
          • Plafond journalier paiements : <strong style={{ color: C.text }}>3 000 000 FCFA</strong><br/>
          • Plafond recharge wallet : <strong style={{ color: C.text }}>3 000 000 FCFA</strong>
        </Section>

        <Section title="7. Conservation des données">
          • Données de compte : durée d'utilisation + 5 ans<br/>
          • Messages : jusqu'à suppression ou expiration<br/>
          • Données financières : 10 ans (réglementation financière)<br/>
          • Logs de connexion : 12 mois
        </Section>

        <Section title="8. Vos droits">
          Vous avez le droit de :<br/><br/>
          • <strong style={{ color: C.text }}>Accéder</strong> à vos données personnelles<br/>
          • <strong style={{ color: C.text }}>Rectifier</strong> vos informations<br/>
          • <strong style={{ color: C.text }}>Supprimer</strong> votre compte et données<br/>
          • <strong style={{ color: C.text }}>Exporter</strong> vos données (portabilité)<br/>
          • <strong style={{ color: C.text }}>Vous opposer</strong> au traitement<br/><br/>
          Contact : <strong style={{ color: C.accent }}>GilbertOdzo@zenvoi.co</strong>
        </Section>

        <Section title="9. Messages éphémères">
          La fonctionnalité de messages éphémères supprime automatiquement vos messages après la durée choisie (1, 7 ou 30 jours). Cette suppression est définitive et irréversible.
        </Section>

        <Section title="10. Cookies et traceurs">
          PayChat est une PWA. Nous utilisons uniquement des jetons d'authentification JWT stockés localement. Aucun cookie publicitaire ou traceur tiers.
        </Section>

        <Section title="11. Modifications">
          En cas de changement significatif, vous serez notifié dans l'application au moins 30 jours avant l'entrée en vigueur.
        </Section>

        <Section title="12. Contact">
          <strong style={{ color: C.text }}>ZENVOI SARL — Délégué à la Protection des Données</strong><br/>
          Email : GilbertOdzo@zenvoi.co<br/>
          Tél : +237 697 008 362 | BP 12619 — Douala, Cameroun
        </Section>

        <div style={{ background: C.card, border: `1px solid ${C.border}`, borderRadius: 16, padding: 20, textAlign: "center", marginTop: 32 }}>
          <div style={{ fontSize: 12, color: C.muted }}>© 2026 ZENVOI SARL — Tous droits réservés</div>
          <div style={{ fontSize: 12, color: C.muted, marginTop: 4 }}>PayChat — https://zenvoi.app</div>
        </div>

      </div>
    </div>
  );
}
